import React from 'react';
import { Linking, Modal } from 'react-native';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';

import { roles } from 'cross-platform/utils/roleProps';

import { LinkText } from '../../styled';

import { CloseButton } from './CloseButton';
import { Body, ContentText, Header, Title } from './styled';

type NeedHelpModalProps = {
  show: boolean;
  onClose: () => void;
};

const NeedHelpModal = ({ show, onClose }: NeedHelpModalProps) => {
  return (
    <Modal
      {...roles('need-help-modal')}
      visible={show}
      onRequestClose={onClose}
      animationType={'slide'}
      supportedOrientations={['landscape', 'portrait']}
    >
      <SafeAreaProvider>
        <SafeAreaView
          style={{ flex: 1, backgroundColor: 'white' }}
          edges={['top', 'left', 'right']}
        >
          <Header>
            <CloseButton onPress={onClose} />
          </Header>
          <Body>
            <Title>Need help?</Title>
            <ContentText>
              You can email us for technical support at{' '}
              <LinkText
                onPress={() => Linking.openURL('mailto:hello@bighealth.com')}
              >
                hello@bighealth.com
              </LinkText>{' '}
              and we&apos;ll respond as soon as possible.
            </ContentText>
          </Body>
        </SafeAreaView>
      </SafeAreaProvider>
    </Modal>
  );
};

export default NeedHelpModal;
